// extracted by mini-css-extract-plugin
export default {"testDate_container":"TestDate_testDate_container__z5Ifl","testDate_box":"TestDate_testDate_box__gC-o1"};